import { type BadgeStatus, StatusBadge } from "@/components/ui/status-badge";
import { cn } from "@/lib/utils";
import type { StaffingRequestStatus } from "@/schemas/staffing-requests";

// Staffing request lifecycle → NOS StatusBadge semantics (amber→pending,
// emerald→completed, red→failed, zinc→disabled).
const STATUS_TO_NOS: Record<StaffingRequestStatus, BadgeStatus> = {
  Pending: "pending",
  Approved: "completed",
  Rejected: "failed",
  Withdrawn: "disabled",
};

interface StaffingStatusBadgeProps {
  status: StaffingRequestStatus;
  className?: string;
}

/** Compact status pill for the request queue and detail header. */
export function StaffingStatusBadge({ status, className }: StaffingStatusBadgeProps) {
  return (
    <StatusBadge
      status={STATUS_TO_NOS[status]}
      className={cn("h-5 px-1.5 text-xs font-semibold", className)}
    >
      {status}
    </StatusBadge>
  );
}
